<template>
  <div class="app-step-one-package-groups">
    <resume-order v-if="authStore.isLoggedIn"></resume-order>

    <div
      v-for="group in groupsWithPackages"
      :key="group.id"
      class="app-step-one-package-groups__group"
    >
      <h2
        v-if="groupsWithPackages.length > 1"
        class="app-step-one-package-groups__group-title"
      >
        {{ group.name }}
      </h2>

      <ul class="app-step-one-package-groups__list">
        <li v-for="pkg in group.packages" :key="pkg.id">
          <app-button
            router
            theme="primary"
            :to="{
              name: 'special-package',
              params: { packageSlug: pkg.urlRewrite },
            }"
          >
            Start {{ pkg.name }} Order
          </app-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

import AppButton from '@modules/ui/app-button.vue'
import ResumeOrder from './resume-order.vue'

const props = defineProps({
  packageGroups: {
    type: Object,
    default: null,
  },
})

const authStore = useAuthStore()

const groupsWithPackages = computed(() => {
  return (
    props.packageGroups?.data?.filter((group) => group.packages?.length) ?? []
  )
})
</script>
